import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LATIN_CONVERTED_CYRILIC, LATIN_SR } from "./locale/latinSr";

export enum Locales {
  LATIN = "lat",
  CYRILIC = "cyr",
}

export const LANGUAGE_OPTIONS = [
  { value: Locales.LATIN, label: "Latinica" },
  { value: Locales.CYRILIC, label: "Ћирилица" },
];

const resources = {
  [Locales.LATIN]: { translation: LATIN_SR },
  [Locales.CYRILIC]: { translation: LATIN_CONVERTED_CYRILIC },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: Locales.LATIN, // language to use
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
